import styled from '@emotion/styled';
import BenefitCardList from '@components/_templates/career/BenefitCard/list';
import { benefitHashTagList } from '@components/_templates/career/BenefitCard';
import { gray } from '@styles/Colors';
import { useMemo, useState } from 'react';

const PeopleBenefitWrapper = styled.div`
  width: 100%;
  display: flex;
  max-width: 1080px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding-bottom: 100px;
  margin: 0 auto;
`;

const PeopleBenefitTitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
`;

const PeopleBenefitTitle = styled.p`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.48px;
`;

const PeopleBenefitHashTagWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

const PeopleBenefitHashTag = styled.p<{ active?: boolean }>`
  display: flex;
  padding: 5px 14px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: var(--gray-scale-gray-4, ${(props) => (props.active ? gray.gray6 : gray.gray4)});
  cursor: pointer;

  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: -0.32px;
`;

export default function PeopleBenefit() {
  const [activeCategoryIndex, setActiveCategoryIndex] = useState<number>(0);
  const categoryList = useMemo(() => ['전체', ...benefitHashTagList.map((item) => `#${item} 속 혜택`)], []);

  return (
    <>
      <PeopleBenefitWrapper>
        <PeopleBenefitTitleWrapper>
          <PeopleBenefitTitle>피플 혜택</PeopleBenefitTitle>
          <PeopleBenefitHashTagWrapper>
            {categoryList.map((item, index) => (
              <PeopleBenefitHashTag
                key={index}
                active={activeCategoryIndex === index}
                onClick={() => setActiveCategoryIndex(index)}>
                {item}
              </PeopleBenefitHashTag>
            ))}
          </PeopleBenefitHashTagWrapper>
        </PeopleBenefitTitleWrapper>
        
        <BenefitCardList categoryName={benefitHashTagList[activeCategoryIndex - 1]} />
      </PeopleBenefitWrapper>
    </>
  );
}
